// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"17b90f6a","908":"61401b83"}[chunkId] + ".chunk.css";
};